import { getRoutes } from "./routes.config";

export type NavbarLink = {
  icon: string;
  iconViewBox: string;
  href: string;
  label: string;
  dataQA: string;
  isNew?: boolean;
  render?: string;
};

export type NavbarItem = {
  label: string;
  dataQA: string;
  isNew?: boolean;
  links: NavbarLink[];
};

export type NavbarConfig = {
  guestLinks: NavbarItem[];
  userLinks: NavbarItem[];
};

export function getNavbarLinks(baseURL: string): NavbarConfig {
  const ROUTES = getRoutes(baseURL);

  const guestLinks = [
    {
      label: "Comprar",
      dataQA: "header_buy",
      isNew: false,
      links: [
        {
          icon: "CarUsedIcon",
          iconViewBox: "",
          href: `${ROUTES.CAR.USED}?lkid=1000`,
          label: "Carros usados",
          dataQA: "header_buy_car_used",
          isNew: false,
        },
        {
          icon: "CarNewIcon",
          iconViewBox: "",
          href: `${ROUTES.CAR.NEW}?lkid=1001`,
          label: "Carros novos",
          dataQA: "header_buy_car_new",
          isNew: false,
        },
        {
          icon: "BikeUsedIcon",
          iconViewBox: "-4 -2 24 24",
          href: `${ROUTES.BIKE.USED}?lkid=1002`,
          label: "Motos usadas",
          dataQA: "header_buy_bike_used",
          isNew: false,
        },
        {
          icon: "BikeNewIcon",
          iconViewBox: "",
          href: `${ROUTES.BIKE.NEW}?lkid=1003`,
          label: "Motos novas",
          dataQA: "header_buy_bike_new",
          isNew: false,
        },
        {
          icon: "InspectedIcon",
          iconViewBox: "-2 -2 24 24",
          href: `${ROUTES.CAR.ALL}?Oportunidades=Vistoriado&lkid=1576`,
          label: "Vistoriado",
          dataQA: "header_buy_inspected",
          isNew: false,
        },
      ],
    },
    {
      label: "Vender",
      dataQA: "header_sell",
      isNew: false,
      links: [
        {
          icon: "CarSellIcon",
          iconViewBox: "",
          href: `${ROUTES.CAR.SELL}?lkid=1006`,
          label: "Vender carro",
          dataQA: "header_sell_car",
          isNew: false,
        },
        {
          icon: "BikeSellIcon",
          iconViewBox: "",
          href: `${ROUTES.BIKE.SELL}?lkid=1007`,
          label: "Vender moto",
          dataQA: "header_sell_bike",
          isNew: false,
        },
        {
          icon: "ManageAdsIcon",
          iconViewBox: "-3 -3 24 24",
          label: "Gerenciar meu anúncio",
          href: `${ROUTES.GARAGE.BASE}?lkid=1009`,
          dataQA: "header_sell_manage_ad",
          isNew: false,
        },
        {
          icon: "DealerPlatformIcon",
          iconViewBox: "",
          href: `${ROUTES.SERVICES.DEALER_PLATFORM}?lkid=1017`,
          label: "Plataforma revendedores",
          dataQA: "header_sell_dealer_platform",
          isNew: false,
        },
      ],
    },
    {
      label: "Financiar",
      dataQA: "header_finance",
      isNew: false,
      links: [
        {
          icon: "FinancingIcon",
          iconViewBox: "",
          href: `${ROUTES.SERVICES.FINANCING}?lkid=3972`,
          label: "Simular financiamento",
          dataQA: "header_services_financing",
          isNew: false,
        }
      ]
    },
    {
      label: "Assinar",
      dataQA: "header_subscriptions",
      isNew: true,
      links: [
        {
          icon: "CarSubscriptionsIcon",
          iconViewBox: "",
          href: `${ROUTES.SUBSCRIPTION}?lkid=3797`,
          label: "Carros por assinatura",
          dataQA: "header_subscriptions_signature_car",
          isNew: false,
        },
      ],
    },
    {
      label: "Serviços",
      dataQA: "header_services",
      isNew: false,
      links: [
        {
          icon: "WebmotorsServicesIcon",
          iconViewBox: "",
          href: `${ROUTES.SERVICES.SERVICES}?lkid=2473`,
          label: "Serviços automotivos",
          dataQA: "header_webmotors_services",
          isNew: false,
        },
        {
          icon: "FipeIcon",
          iconViewBox: "",
          href: `${ROUTES.SERVICES.FIPE}?lkid=1010`,
          label: "Tabela FIPE e Tabela Webmotors",
          dataQA: "header_services_fipe",
          isNew: false,
        },
        {
          icon: "FinancingIcon",
          iconViewBox: "",
          href: `${ROUTES.SERVICES.FINANCING}?lkid=1011`,
          label: "Financiamento",
          dataQA: "header_services_financing",
          isNew: false,
        },
        {
          icon: "ConsorcioIcon",
          iconViewBox: "",
          href: `${ROUTES.SERVICES.CONSORCIO}?lkid=2301`,
          label: "Consórcio",
          dataQA: "header_services_consorcio",
          isNew: true,
        },
        {
          icon: "CatalogIcon",
          iconViewBox: "",
          href: `${ROUTES.CAR.ZERO}?lkid=1012`,
          label: "Catálogo 0km",
          dataQA: "header_services_catalog",
          isNew: false,
        },
        {
          icon: "InspectedIcon",
          iconViewBox: "-2 -2 24 24",
          href: `${ROUTES.COCKPIT}solutions/vistoriado?lkid=1577`,
          label: "Vistoriado",
          dataQA: "header_services_inspected",
          isNew: false,
        },
        {
          icon: "DealerPlatformIcon",
          iconViewBox: "",
          href: `${ROUTES.SERVICES.DEALER_PLATFORM}?lkid=1017`,
          label: "Plataforma revendedores",
          dataQA: "header_services_dealer_platform",
          isNew: false,
        },
        {
          icon: "InsuranceIcon",
          iconViewBox: "-3 -3 24 24",
          href: `${ROUTES.SERVICES.INSURANCE}?lkid=1015&utm_source=webmotors&utm_medium=site&utm_campaign=menu_servicos_seguro_veiculo`,
          label: "Seguro veículo",
          dataQA: "header_services_insurance",
          isNew: false,
        },
      ],
    },
    {
      label: "Notícias WM1",
      dataQA: "header_wm1",
      isNew: false,
      links: [
        {
          icon: "PortalIcon",
          iconViewBox: "-2 -4 24 24",
          href: `${ROUTES.WM1.PORTAL}?lkid=1549`,
          label: "Portal",
          dataQA: "header_wm1_portal",
          isNew: false,
        },
        {
          icon: "LastNewsIcon",
          iconViewBox: "",
          href: `${ROUTES.WM1.LASTNEWS}?lkid=1550`,
          label: "Últimas notícias",
          dataQA: "header_wm1_lastnews",
          isNew: false,
        },
        {
          icon: "TestsIcon",
          iconViewBox: "",
          href: `${ROUTES.WM1.TESTS}?lkid=1551`,
          label: "Testes",
          dataQA: "header_wm1_tests",
          isNew: false,
        },
        {
          icon: "ComparativesIcon",
          iconViewBox: "",
          href: `${ROUTES.WM1.COMPARATIVES}?lkid=1552`,
          label: "Comparativos",
          dataQA: "header_wm1_comparatives",
          isNew: false,
        },
        {
          icon: "VideosIcon",
          iconViewBox: "-2 -6 24 24",
          href: `${ROUTES.WM1.VIDEOS}?lkid=1553`,
          label: "Vídeos",
          dataQA: "header_wm1_videos",
          isNew: false,
        },
        {
          icon: "BikeUsedIcon",
          iconViewBox: "-4 -2 24 24",
          href: `${ROUTES.WM1.BIKES}?lkid=1554`,
          label: "Motos",
          dataQA: "header_wm1_bikes",
          isNew: false,
        },
        {
          icon: "SecretsIcon",
          iconViewBox: "-2 -2 24 24",
          href: `${ROUTES.WM1.SECRETS}?lkid=1555`,
          label: "Segredos",
          dataQA: "header_wm1_secrets",
          isNew: false,
        },
        {
          icon: "TipsIcon",
          iconViewBox: "",
          href: `${ROUTES.WM1.TIPS}?lkid=1556`,
          label: "Dicas",
          dataQA: "header_wm1_tips",
          isNew: false,
        },
        {
          icon: "PocketIcon",
          iconViewBox: "",
          href: `${ROUTES.WM1.POCKET}?lkid=1557`,
          label: "Bolso",
          dataQA: "header_wm1_pocket",
          isNew: false,
        },
      ],
    },
    {
      label: "Ajuda",
      dataQA: "header_help",
      isNew: false,
      links: [
        {
          icon: "HelpYouIcon",
          iconViewBox: "-4 -4 24 24",
          href: `${ROUTES.HELP.YOU}?lkid=1018`,
          label: "Para você",
          dataQA: "header_help_you",
          isNew: false,
        },
        {
          icon: "HelpStoreIcon",
          iconViewBox: "",
          href: `${ROUTES.HELP.STORE}?lkid=1019`,
          label: "Para sua loja",
          dataQA: "header_help_store",
          isNew: false,
        },
        {
          icon: "HelpSecurityIcon",
          iconViewBox: "-3 -2 24 24",
          href: `${ROUTES.HELP.SECURITY}?lkid=2173`,
          label: "Segurança",
          dataQA: "header_help_security",
          isNew: false,
        },
      ],
    },
  ];

  const userLinks = [
    {
      label: "Minha Garagem",
      dataQA: "header_myGarage",
      links: [
        {
          icon: "ManageAdsIcon",
          iconViewBox: "-3 -3 24 24",
          href: ROUTES.GARAGE.BASE,
          label: "Meus anúncios",
          dataQA: "header_myGarage_myAds",
        },
        {
          icon: "EditIcon",
          iconViewBox: "",
          href: ROUTES.GARAGE.PERFIL,
          label: "Minha conta",
          dataQA: "header_myGarage_myAccount",
        },
        {
          icon: "FavoritesIcon",
          iconViewBox: "",
          href: ROUTES.GARAGE.FAVORITES,
          label: "Favoritos",
          dataQA: "header_myGarage_favorites",
          render: "mobileOnly",
        },
      ],
    },
  ];

  return {
    guestLinks,
    userLinks,
  };
}
